export function getCheckbetPage(isMobile) {
	const defaultCheckbetPage = '/checkbet';
	if (isMobile) {
		return (window.appConfig && window.appConfig.ROUTES && window.appConfig.ROUTES.prematch && window.appConfig.ROUTES.prematch.checkbet) || defaultCheckbetPage;
	}else{
		return (window.appConfig && window.appConfig.ROUTES && window.appConfig.ROUTES.checkbet && window.appConfig.ROUTES.checkbet['checkbet']) || defaultCheckbetPage;
	}
}
